import {
  SidebarContent,
  SidebarGroup,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { mockNotification } from './mock-notification'
import { ContestCard } from '@/components/common'
import { CheckCheckIcon, EllipsisVertical, Trash2Icon } from 'lucide-react'
import { Settings } from 'lucide-react'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Timeline } from './timeline'

export function AppSidebarContent() {
  return (
    <>
      <SidebarSeparator className="mx-0 h-[0.5px] bg-black" />
      <SidebarContent>
        <SidebarGroup>
          <Tabs defaultValue="new" className="w-full font-darkergrotesque">
            <div className="my-6 ml-3 flex items-center justify-between">
              <TabsList className="rounded-full">
                <TabsTrigger
                  value="new"
                  className="rounded-full px-3 py-1 font-darkergrotesque text-lg"
                >
                  New
                </TabsTrigger>
                <TabsTrigger
                  value="reminder"
                  className="rounded-full px-3 py-1 font-darkergrotesque text-lg"
                >
                  Reminder
                </TabsTrigger>
              </TabsList>

              <Popover>
                <PopoverTrigger>
                  <EllipsisVertical />
                </PopoverTrigger>
                <PopoverContent className="inline-flex min-w-64 flex-initial flex-col gap-3 bg-white">
                  <div className="flex items-center gap-2">
                    <Settings className="h-6 w-6 shrink-0" />
                    <span>Notification settings</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCheckIcon className="h-6 w-6 shrink-0" />
                    <span>Mark all as read</span>
                  </div>
                  <div className="flex items-center gap-2 text-red-500">
                    <Trash2Icon className="h-6 w-6 shrink-0" />
                    <span>Delete all notifications</span>
                  </div>
                </PopoverContent>
              </Popover>
            </div>

            <TabsContent value="new">
              <div className="flex flex-col gap-4 p-2">
                {mockNotification.map((item) => {
                  // @ts-expect-error - Fix this later
                  return <ContestCard key={item.id} contest={item} />
                })}
              </div>
            </TabsContent>

            <TabsContent value="reminder">
              <Timeline />
            </TabsContent>
          </Tabs>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
